var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinBetween({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19354_19863",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19354_19863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 12.5V11.5H14.6667V12.5H9.33337Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 8.00033L4.66671 11.3337L5.60004 10.4003L3.88337 8.66699H9.78818C10.4217 8.24576 11.1822 8.00033 12 8.00033C12.7629 8.00033 13.4759 8.21389 14.0825 8.5845L14.6667 8.00033L11.3334 4.66699L10.4 5.60033L12.1167 7.33366H3.88337L5.60004 5.60033L4.66671 4.66699L1.33337 8.00033Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinBetween);
export default __webpack_public_path__ + "static/media/min-between.b84afac1d0f309be284b4c796e80cffe.svg";
export { ForwardRef as ReactComponent };